import React from 'react'
import { Modal } from 'react-bootstrap'

const SuccessModal = ({ isOpen, prompt }) => {
    return (
        <Modal
            show={isOpen}
            centered
            className="success-modal"
            backdrop="static"
        >
            <Modal.Body>
                <div className="p-sm-5">
                    <h2 className="font-16 lh-16 my-3 my-sm-5 fw-normal text-center">{prompt}</h2>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default SuccessModal
